import { httpClient } from '@/utils/httpClient';

export interface PurchaseRequisitionItem {
  catalogId: string;
  quantity: number;
  actualPrice?: number;
}

export interface PurchaseRequisitionRequest {
  items: PurchaseRequisitionItem[];
  purchaseType?: 'GPC' | 'Natick/MIPR' | 'Contract' | 'GPC/GSA 25K' | 'MILSTRIP';
  description?: string;
  ufr?: boolean;
  logFormNumber: number;
  assetAuthority?: string;
  priority?: string;
  vendor?: string;
  expectedDeliveryDate?: string;
  requiredByDate?: string;
  fmz?: string;
  wbsCc?: string;
}

export interface PurchaseRequisitionResponse {
  orderId: string;
  orderIdentifier: string;
  documentNumber?: string;
  lineItemCount: number;
  lineItemIds: string[];
  totalItemQuantity: number;
  transactionId?: string;
}

export interface CancelPurchaseRequisitionRequest {
  orderId: string;
  cancellationReason: string;
}

export interface CancelPurchaseRequisitionResponse {
  orderId: string;
  orderIdentifier: string;
  status: 'Cancelled';
}

export interface CancelPurchaseRequisitionLineItemRequest {
  orderId: string;
  lineItemId: string;
  quantityToCancel: number;
  cancellationReason: string;
}

export interface CancelPurchaseRequisitionLineItemResponse {
  orderId: string;
  orderIdentifier: string;
  lineItemId: string;
  remainingQuantity: number;
  status: 'Pending' | 'Cancelled';
}

class PurchaseRequisitionService {
  async completePurchaseRequisition(
    request: PurchaseRequisitionRequest,
  ): Promise<PurchaseRequisitionResponse> {
    return httpClient.post<PurchaseRequisitionResponse>(
      '/api/v1/purchase-requisition/complete',
      request,
    );
  }

  async cancelPurchaseRequisition(
    request: CancelPurchaseRequisitionRequest,
  ): Promise<CancelPurchaseRequisitionResponse> {
    return httpClient.post<CancelPurchaseRequisitionResponse>(
      '/api/v1/purchase-requisition/cancel',
      request,
    );
  }

  async cancelPurchaseRequisitionLineItem(
    request: CancelPurchaseRequisitionLineItemRequest,
  ): Promise<CancelPurchaseRequisitionLineItemResponse> {
    return httpClient.post<CancelPurchaseRequisitionLineItemResponse>(
      '/api/v1/purchase-requisition/cancel-line-item',
      request,
    );
  }
}

export const purchaseRequisitionService = new PurchaseRequisitionService();
